import * as Tooltip from "@radix-ui/react-tooltip";
import styled, { css } from "styled-components";
import { getThemeSpace } from "../helpers";
export const Provider = styled(Tooltip.Provider) ``;
export const Root = styled(Tooltip.Root) ``;
export const Trigger = styled(Tooltip.Trigger) `
	display: inherit;
	padding: 0;

	width: inherit;
`;
export const Content = styled(Tooltip.Content) `
	padding: ${getThemeSpace("4")} ${getThemeSpace("8")};

	border-radius: 4px;
	background-color: var(--text-primary);
	height: fit-content;
	max-width: ${({ maxWidth }) => maxWidth};
	width: 100%;

	color: var(--neutral-white);
	font-size: 14px;
	line-height: 18px;
	white-space: normal;
	z-index: 1000;

	&::after {
		position: absolute;
		bottom: 0;
		left: 50%;
		content: '';
		width: 12px;
		height: 12px;

		background-color: var(--surface-primary);
		transform: translate(-50%, -50%) rotate(45deg);
		z-index: -1;

		${({ side }) => side === "bottom" &&
    css `
				top: 12px;
			`}

		${({ side }) => side === "left" &&
    css `
				bottom: calc(50% - 12px);
				left: calc(100% - 12px);
			`}

		${({ side }) => side === "right" &&
    css `
				bottom: calc(50% - 12px);
				left: 12px;
			`}
	}
`;
//# sourceMappingURL=styles.js.map